import {Box} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/component/Box';
import {Page} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/Page';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {BoxTitle} from '@mintdata-wsp/wsp/ui/views/visualDesigner/surface/area/BoxTitle';
import {PageOverlaysTabs} from '@mintdata-wsp/wsp/ui/views/visualDesigner/surface/area/PageOverlaysTabs';
import * as classnames from 'classnames/bind';
import {computed, untracked} from 'mobx';
import {observer} from 'mobx-react';
import * as React from 'react';
import {CSSProperties} from 'react';

const styles = require('./BoxDecorator.less');
const cx = classnames.bind(styles);

export interface BoxDecoratorProps
{
    className?:string;
    style?:CSSProperties;
    box:Box;
    isReactive?:boolean;
}

@observer
export class BoxDecorator extends React.Component<BoxDecoratorProps, any>
{
    public static defaultProps:Partial<BoxDecoratorProps> = {
        isReactive: true
    };

    public render():JSX.Element
    {
        if( this.props.isReactive )
            return this._render();

        return untracked(() => this._render());
    }

    private _render():JSX.Element
    {
        const {surfaceArea} = controllers.ui;
        const {className, style, box} = this.props;
        const {page} = box;
        const activePage:Page = surfaceArea.getActivePage();
        const isInActivePage:boolean = activePage && activePage.id === page.id;

        const isViewportOnActivePage:boolean = box.isViewport && isInActivePage;

        if( !isViewportOnActivePage && this._areMultipleBoxesSelected )
            return null;

        const {rotationProp} = box.componentDesc;

        const isRotationEnabled = rotationProp.value.isEnabled.value;

        if( isRotationEnabled && rotationProp.value.angle.value % 360 !== 0 ) return null;

        const displayName:string = surfaceArea.getBoxName(box);

        return (
            <div className={cx('boxDecoratorContainer', className)} style={style}>
                {!box.isViewport && <BoxTitle displayName={displayName} />}

                {isViewportOnActivePage && <PageOverlaysTabs page={page} />}
            </div>
        );
    }

    @computed
    private get _areMultipleBoxesSelected():boolean
    {
        const {surfaceSelection} = controllers.ui;

        return surfaceSelection.areMultipleBoxesSelected();
    }
}
